import { Divider, Paper } from "@mui/material";
import React, { useEffect, useState } from "react";
import AuthService from "../../AuthService";
import Template from "../Generico/Template";
import TituloPrincipal from "../Generico/TituloPrincipal";
import DialogEditEnterprise from "./components/DialogEditEnterprise";
import HeaderSearch from "./components/HeaderSearch";
import TableList from "./components/TableList";

function Empresas() {
  const [empresas, setEmpresas] = useState([]);
  const [pesquisa, setPesquisa] = useState("");
  const [listar, setListar] = useState("todos");
  const [listarBloqueio, setListarBloqueio] = useState("todosDtBloqueio");
  const [listaridExterno, setListaridExterno] = useState("todosIdExterno");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [editEmpresa, setEditEmpresa] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(
    window.screen.width <= 560 ? 500 : 10
  );

  useEffect(() => {
    setLoading(true);
    buscarEmpresas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  const buscarEmpresas = () => {
    const service = new AuthService();
    const ativo =
      listar === "ativos" ? true : listar === "inativos" ? false : "null";
    const url = `/empresa/listBusca?q=${pesquisa}&ativo=${ativo}&dtBloqueio=${listarBloqueio}&idExterno=${listaridExterno}&first=${
      rowsPerPage * page
    }&max=${rowsPerPage}`;
    service
      .request(url)
      .then((response) => {
        const totalCount = parseInt(response.headers.get("totalCount"));
        setTotalCount(totalCount);
        return response.json();
      })
      .then((data) => {
        setEmpresas(data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  };

  const handleChangeDataBloqueio = (value) => {
    if (value === "Invalid Date") return;
    setEditEmpresa((prev) => ({
      ...prev,
      dataBloqueio: value,
    }));
  };

  const handleAtivar = (event) => {
    if (!event) return;
    setEditEmpresa((prev) => ({
      ...prev,
      ativo: event.target.checked,
    }));
  };

  const handlePesquisa = () => {
    setLoading(true);
    buscarEmpresas();
  };

  const handleRadio = (event) => {
    setListar(event.target.value);
  };

  const handleRadioBloqueio = (event) => {
    setListarBloqueio(event.target.value);
  };

  const handleRadioidExterno = (event) => {
    setListaridExterno(event.target.value);
  };

  const handleChangePesquisa = (event) => {
    setPesquisa(event.target.value);
  };

  const handleOpenConfig = () => {
    setOpen((prev) => !prev);
  };

  const handleEditEmpresa = (empresa) => {
    setEditEmpresa(empresa);
    setOpen(true);
  };

  const handleClose = () => {
    setEditEmpresa(null);
    setOpen(false);
  };

  const handleSave = () => {
    const service = new AuthService();
    service
      .post("/empresa", editEmpresa)
      .then(() => {
        setEditEmpresa(null);
        setOpen(false);
      })
      .then(() => {
        setLoading(true);
        buscarEmpresas();
      })
      .catch((err) => console.error("erro", err));
  };

  const handleEnterPressionar = (e) => {
    if (e.key === "Enter") {
      handlePesquisa();
    }
  };

  const handleChangePage = (__, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const verificaPendencias = () => {
    const service = new AuthService();
    service.get(`/empresa/VerificaBoleto/${editEmpresa.id}`).then((resp) => {
      const updated = empresas.map((el) =>
        el.id === editEmpresa.id ? resp : el
      );
      setEmpresas(updated);
      handleClose();
    });
  };

  const verificaPendenciasAll = () => {
    const service = new AuthService();
    service
      .get("/empresa/VerificaBoletoAll")
      .then((resp) => {
        setEmpresas(resp);
        setListarBloqueio("todosDtBloqueio");
        setListar("todos");
      })
      .catch((err) => console.error(err));
  };

  const handleChange = (event) => {
    if (event.target.name === "idExterno") {
      setEditEmpresa((prev) => ({
        ...prev,
        idExterno: event.target.value,
      }));
    }
  };

  const handleLiberarEmpresa = () => {
    const service = new AuthService();
    service
      .get(`/empresa/liberarEmpresa/${editEmpresa.id}`)
      .then((resp) => {
        const updated = empresas.map((el) =>
          el.id === editEmpresa.id ? resp : el
        );
        setEmpresas(updated);
        handleClose();
      })
      .then(() => {
        setLoading(true);
        buscarEmpresas();
      });
  };

  return (
    <Template documentTitle="Lista de empresas">
      <TituloPrincipal
        title="Lista de empresas"
        subTitle="Configure as opções das empresas"
      />
      <Paper>
        <HeaderSearch
          handleEnterPressionar={handleEnterPressionar}
          handleChangePesquisa={handleChangePesquisa}
          handlePesquisa={handlePesquisa}
          verificaPendenciasAll={verificaPendenciasAll}
          handleRadio={(e) => {
            handleRadio(e);
          }}
          listar={listar}
          listarBloqueio={listarBloqueio}
          listaridExterno={listaridExterno}
          handleRadioBloqueio={(e) => {
            handleRadioBloqueio(e);
          }}
          handleRadioidExterno={(e) => {
            handleRadioidExterno(e);
          }}
        />
        <Divider />
        <TableList
          empresas={empresas}
          page={page}
          totalCount={totalCount}
          isLoading={loading}
          rowsPerPage={rowsPerPage}
          handleEditEmpresa={handleEditEmpresa}
          handleChangePage={handleChangePage}
          handleRowsPerPage={handleRowsPerPageChange}
        />
      </Paper>
      <DialogEditEnterprise
        editEmpresa={editEmpresa}
        open={open}
        handleOpenConfig={handleOpenConfig}
        handleChangeDataBloqueio={handleChangeDataBloqueio}
        handleSave={handleSave}
        handleClose={handleClose}
        verificaPendencias={verificaPendencias}
        handleChange={handleChange}
        handleAtivar={handleAtivar}
        handleLiberarEmpresa={handleLiberarEmpresa}
      />
    </Template>
  );
}

export default Empresas;
